module.exports = __webpack_public_path__ + "static/montserrat-latin-700-39d93cf678c740f9f6b2b1cfde34bee3.woff2";